export const getDues = (invoice = {}) => {
    const invoiceType = invoice?.invoice_type?.name;
    const totalEndBalance = Number(invoice?.total_end_balance ?? 0);
    const customInvoiceAmount = Number(invoice?.custom_invoice_amount ?? 0);

    if(invoiceType==='On-Demand' || invoiceType==='Credit Card Deposit') 
    {
       return {
            label: 'Total Due',
            amount: `$${(totalEndBalance * -1).toFixed(2)}`
       }
    }   
    else 
    {
        if( invoiceType==='Monthly' ||  invoiceType === 'Advance Pay' )  {
            return {
                label: 'Invoice Total',
                amount: `$${customInvoiceAmount.toFixed(2)}`
            }
        }   else {
            return {
                label: 'Balance Due',
                amount: `$${(totalEndBalance * -1).toFixed(2)}`
            }
        }
    }
}